export const RedEmailIcon = () => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25.5156" r="25" fill="#FFCBD0" />
      <path
        d="M33.75 23.7654C33.655 23.7105 33.5472 23.6816 33.4375 23.6816C33.3278 23.6816 33.22 23.7105 33.125 23.7654L25 28.3591L16.875 23.7654C16.7798 23.7104 16.6718 23.6815 16.5619 23.6816C16.452 23.6817 16.344 23.7108 16.2489 23.766C16.1538 23.8211 16.075 23.9004 16.0203 23.9958C15.9656 24.0911 15.9371 24.1992 15.9375 24.3091V29.7029C15.9375 30.2002 16.135 30.6771 16.4867 31.0287C16.8383 31.3803 17.3152 31.5779 17.8125 31.5779H32.1875C32.6848 31.5779 33.1617 31.3803 33.5133 31.0287C33.865 30.6771 34.0625 30.2002 34.0625 29.7029V24.3123C34.0635 24.2016 34.0351 24.0927 33.9802 23.9966C33.9253 23.9005 33.8458 23.8207 33.75 23.7654Z"
        fill="#E1000F"
      />
      <path
        d="M32.1875 18.4531H17.8125C17.3152 18.4531 16.8383 18.6507 16.4867 19.0023C16.135 19.3539 15.9375 19.8308 15.9375 20.3281V21.5C15.9371 21.6101 15.9657 21.7184 16.0206 21.8139C16.0755 21.9094 16.1546 21.9887 16.25 22.0437L24.6875 26.8094C24.7825 26.8642 24.8903 26.8931 25 26.8931C25.1097 26.8931 25.2175 26.8642 25.3125 26.8094L33.75 22.0437C33.8454 21.9887 33.9245 21.9094 33.9794 21.8139C34.0343 21.7184 34.0629 21.6101 34.0625 21.5V20.3281C34.0625 19.8308 33.865 19.3539 33.5133 19.0023C33.1617 18.6507 32.6848 18.4531 32.1875 18.4531Z"
        fill="#E1000F"
      />
    </svg>
  );
};
